import React, {useEffect, useState} from "react";
import "./CustomScripts.css";
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';
import CustomScript from "./CustomScript";

import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrashCan, faFileCode as faFileCodeRegular} from "@fortawesome/free-regular-svg-icons";
import {faFileCode} from "@fortawesome/free-solid-svg-icons";

import CustomScriptData from "./CustomScriptData";

import sampleScripts from "./samples";


const CustomScripts = ({bond}) => {
    const [currentScript, setCurrentScript] = useState(null);
    const [savedScripts, setSavedScripts] = useState([]);

    function onLoad() {
        let customScriptData = JSON.parse(localStorage.getItem('customScripts'));
        if (customScriptData && customScriptData.length > 0) {
            setSavedScripts(customScriptData)
            setCurrentScript(customScriptData[0])
        } else {
            setSavedScripts(sampleScripts)
            setCurrentScript(sampleScripts[0]);
            localStorage.setItem('customScripts', JSON.stringify(sampleScripts));
        }
    }

    useEffect(onLoad, []);

    function onSave(title, code) {
        let customScriptData = JSON.parse(localStorage.getItem('customScripts'));
        if (!customScriptData) customScriptData = []; else {
            for (let i = 0; i < customScriptData.length; i++) {
                if (customScriptData[i].title === title) {
                    customScriptData[i].code = code;
                    localStorage.setItem('customScripts', JSON.stringify(customScriptData));
                    setSavedScripts(customScriptData);
                    return;
                }
            }
        }
        customScriptData.push(new CustomScriptData(title, code));
        localStorage.setItem('customScripts', JSON.stringify(customScriptData));
        setSavedScripts(customScriptData)
    }

    function onDelete(index) {
        let customScriptData = JSON.parse(localStorage.getItem('customScripts'));
        customScriptData.splice(index, 1);
        localStorage.setItem('customScripts', JSON.stringify(customScriptData));
        setSavedScripts(customScriptData);
    }

    return (<div>
        <DropdownButton variant={"secondary"} title={<><FontAwesomeIcon icon={faFileCode}/> Select</>}
                        className={"dropdownScripts"}>
            {savedScripts.map((script, index) => <Dropdown.Item key={index} onClick={() => setCurrentScript(script)}>

                <div className={"dropdownScriptTitle"}><span className={"align-middle"}><FontAwesomeIcon
                    icon={faFileCodeRegular}/> {script.title}</span></div>
                <Button variant={"outline-danger"}
                        className={"dropdownScriptBtn"}
                        onClick={() => {
                            onDelete(index)
                        }}><FontAwesomeIcon icon={faTrashCan}/>
                </Button>
            </Dropdown.Item>)}
        </DropdownButton>
        <CustomScript bond={bond} currentScript={currentScript} onSave={onSave}></CustomScript>
    </div>);
}

export default CustomScripts;